import React, { useState } from "react";
import ProductReview from "../../pages/CategoriesPageSection/ProductReview.jsx";

const ProductDetail = () => {
  const [activeTab, setActiveTab] = useState("details");

  return (
    <div className="product-detail-section">
      <div className="product-detail-tabs">
        <span
          className={`tab ${activeTab === "details" ? "active" : ""}`}
          onClick={() => setActiveTab("details")}
        >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80H240Zm0-80h480v-640h-80v280l-100-60-100 60v-280H240v640Zm0 0v-640 640Zm200-360 100-60 100 60-100-60-100 60Z"/></svg>
  <span className="tab-icon">
          </span>
          Product Details
        </span>
        <span
          className={`tab ${activeTab === "reviews" ? "active" : ""}`}
          onClick={() => setActiveTab("reviews")}
        >
         <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FF8c00"><path d="m384-334 96-74 96 74-36-122 90-64H518l-38-124-38 124H330l90 64-36 122ZM233-120l93-304L80-600h304l96-320 96 320h304L634-424l93 304-247-188-247 188Zm247-369Z"/></svg> <span className="tab-icon"></span>
          Reviews
        </span>
      </div>

      {activeTab === "details" ? (
        <div className="product-detail-content">
          <div className="detail-intro">
            <p>
              A fully automatic variant of the CZ75, the CZ75-Auto is the ideal
              short-term choice for turning the tables and gaining your opponents
              weapon. But with very little ammo in the magazine, strong trigger
              discipline is required. <span className="highlight-text">A custom paint job with nine purple and gold
              snakes has been applied.</span> Beware the rising tide
            </p>
          </div>

          <div className="detail-grid">
            <div className="product-detail-block">
              <div className="detail-icon"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M582-298 440-440v-200h80v167l118 118-56 57ZM440-720v-80h80v80h-80Zm280 280v-80h80v80h-80ZM440-160v-80h80v80h-80ZM160-440v-80h80v80h-80ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></div>
              <div className="detail-content">
                <div className="detail-title">History</div>
                <div className="detail-text">
                  The CZ75-Auto | Xiangliu was first introduced to CS2 8 years ago,
                  on March 15th, 2017. It was released as part of the Spectrum Case,
                  alongside the "Take a trip to the Canals" update. The skin was
                  created by the community designer "The Honey Badger".
                </div>
              </div>
            </div>

            <div className="product-detail-block">
              <div className="detail-icon"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M760-120q-39 0-70-22.5T647-200H440q-66 0-113-47t-47-113q0-66 47-113t113-47h80q33 0 56.5-23.5T600-600q0-33-23.5-56.5T520-680H313q-13 35-43.5 57.5T200-600q-50 0-85-35t-35-85q0-50 35-85t85-35q39 0 69.5 22.5T313-760h207q66 0 113 47t47 113q0 66-47 113t-113 47h-80q-33 0-56.5 23.5T360-360q0 33 23.5 56.5T440-280h207q13-35 43.5-57.5T760-360q50 0 85 35t35 85q0 50-35 85t-85 35ZM200-680q17 0 28.5-11.5T240-720q0-17-11.5-28.5T200-760q-17 0-28.5 11.5T160-720q0 17 11.5 28.5T200-680Z"/></svg></div>
              <div className="detail-content">
                <div className="detail-title">Origin</div>
                <div className="detail-text">
                  The CZ75-Auto | Xiangliu can be obtained by opening a Spectrum
                  Case container. The skin is also part of the The Spectrum
                  Collection.
                </div>
              </div>
            </div>

            <div className="product-detail-block">
              <div className="detail-icon"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M80-400q-33 0-56.5-23.5T0-480v-240q0-12 5-23t13-19l198-198 30 30q6 6 10 15.5t4 18.5v8l-28 128h208q17 0 28.5 11.5T480-720v50q0 6-1 11.5t-3 10.5l-90 212q-7 17-22.5 26.5T330-400H80Zm238-80 82-194v-6H134l24-108-78 76v232h238ZM744 0l-30-30q-6-6-10-15.5T700-64v-8l28-128H520q-17 0-28.5-11.5T480-240v-50q0-6 1-11.5t3-10.5l90-212q8-17 23-26.5t33-9.5h250q33 0 56.5 23.5T960-480v240q0 12-4.5 22.5T942-198L744 0ZM642-480l-82 194v6h266l-24 108 78-76v-232H642Zm-562 0v-232 232Zm800 0v232-232Z"/></svg></div>
              <div className="detail-content">
                <div className="detail-title">Popularity</div>
                <div className="detail-text">
                  With a popularity of <span className="stat-highlight">90%</span>, the CZ75-Auto | Xiangliu is currently
                  extremely popular, which makes it one of the most popular items in
                  CS2. This popularity measurement is based on the daily sales volume
                  and the price of the skin.
                </div>
              </div>
            </div>

            <div className="product-detail-block">
              <div className="detail-icon"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M438-226 296-368l58-58 84 84 168-168 58 58-226 226ZM200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/></svg></div>
              <div className="detail-content">
                <div className="detail-title">Rarity</div>
                <div className="detail-text">
                  The CZ75-Auto | Xiangliu is one of 415 other Pistol skins. The
                  rarity of the skin is <span className="rarity-badge">Classified</span>, which makes the Xiangliu a very
                  rare drop with an estimated drop chance of only <span className="stat-highlight">3.2%</span>.
                </div>
              </div>
            </div>
          </div>

     {/* <div className="specifications-section">
  <div className="spec-title">Specifications</div>
  <ul className="product-detail-list">
    <li><span className="bullet"></span> Weapon: AK-47</li>
    <li><span className="bullet"></span> Skin Name: Neon Revolution</li>
    <li><span className="bullet"></span> Rarity: Covert (Red)</li>
    <li><span className="bullet"></span> Exterior: Factory New</li>
    <li><span className="bullet"></span> Float Value: 0.05</li>
    <li><span className="bullet"></span> Finish Style: Custom Paint</li>
    <li><span className="bullet"></span> Pattern Template: 843</li>
    <li><span className="bullet"></span> StatTrak™ Available: Yes</li>
    <li><span className="bullet"></span> Release Date: August 19, 2016 (Gamma 2 Case)</li>
    <li><span className="bullet"></span> Collection: Gamma 2 Collection</li>
    <li><span className="bullet"></span> Market Price: $89.75 (Factory New)</li>
    <li><span className="bullet"></span> Item ID: AK47-NEONREV-FN-ST</li>
  </ul>
</div> */}


          <div className="more-faves-section">
            <div className="more-faves-header">
              <div className="more-faves-title">More Faves This Way</div>
              <div className="more-faves-subtitle">Explore similar collections</div>
            </div>
            <div className="more-faves-tags">
              <span className="fave-tag">Stickers</span>
              <span className="fave-tag">Pistols</span>
              <span className="fave-tag">Mid-Tier</span>
              <span className="fave-tag">Collections</span>
              <span className="fave-tag">Rifles</span>
              <span className="fave-tag">Gloves</span>
              <span className="fave-tag">Cases</span>
              <span className="fave-tag">Agents</span>
            </div>
          </div>
        </div>
      ) : (
        <ProductReview />
      )}
    </div>
  );
};

export default ProductDetail;